import * as React from 'react';

/**
 * @description UploadCloud icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { UploadCloud } from '@sravni/design-system-icons'
 *
 * <UploadCloud />
 * ```
 */
const UploadCloud = React.forwardRef((props, ref) => (React.createElement("svg", { ref: ref, "data-qa": "UploadCloud", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
    React.createElement("g", { clipPath: "url(#UploadCloud__a)", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" },
        React.createElement("path", { d: "M10.004 9.998v6.429M15.996 14.562a3.571 3.571 0 0 0-1.707-6.707h-.9a5.713 5.713 0 1 0-9.814 5.214" }),
        React.createElement("path", { d: "m12.86 12.855-2.856-2.857-2.858 2.857" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "UploadCloud__a" },
            React.createElement("path", { fill: "currentColor", d: "M0 0h20v20H0z" }))))));

export { UploadCloud };
//# sourceMappingURL=UploadCloud.js.map
